// removed by extract-text-webpack-plugin
module.exports = {"container":"c-RadioGroup__container","column":"c-RadioGroup__column"};